/**
 * Face mixin
 *
 * Добавляет логику для работы с распознаванием лиц
 *
 */

import { FaceType, FaceTrainStep } from '@pb/api/dist/src/services/face_recognize';

console.log('FaceType', FaceType);

export default {
  data() {
    return {
      facesInfo: [],
      isGeneralSettedByTouch: false,
    };
  },
  computed: {
    faces() {
      return this.facesInfo
        .filter((face) => face.type > FaceType.None); // все лица (распознанные и нет)
    },
    shouldIgnoreGeneralFace() {
      return this.faces.length > 1 && !this.isGeneralSettedByTouch;
    },
    generalFace() {
      return this.faces.find((face) => face.is_tracking && face.id > -1);
    },
  },
  created() {
    this.initFaceActions();
    this.checkFaceCount();
  },
  methods: {
    addNewFace(face, name) {
      return new Promise((resolve, reject) => {
        if (!face) {
          reject(new TypeError('face is required'));
        }
        if (face.type !== FaceType.Unknown) {
          reject(new RangeError('face type should be Unknown (3)'));
        }

        const id = Math.round(new Date().getTime() / 1000);
        const { age, gender } = face;
        const user = {
          id, name, age, gender,
        };

        const unsubscribe = this.$robot.faceRecognizeService.onFaceAddStatus(async (step) => {
          if (step === FaceTrainStep.FACE_TRAINED) {
            const isAdded = await this.$robot.userService.addUser(user);
            if (isAdded) {
              unsubscribe();
              this.$robot.faceRecognizeService.refreshFaces();
              resolve(user);
            } else {
              // Если не удалось познакомиться, то необходимо удалить лицо на роботе
              this.$robot.faceRecognizeService.delFace(id);
              reject(new Error('Can`t add user to database'));
            }
          }
        });

        this.$robot.faceRecognizeService.tempToGeneral(face.id, id);
      });
    },
    pickFaceByCoordinates(coordinates) {
      return this.$robot.faceRecognizeService.touchGeneral(coordinates);
    },
    onGeneralSettedByTouch(id) {
      if (id > -1) {
        this.isGeneralSettedByTouch = true;
        if (this.generalFace && id === this.generalFace.id) {
          this.onGeneralFaceChanged(this.generalFace);
        }
      }
    },
    onGeneralFaceChanged(face) {
      if (face && !this.shouldIgnoreGeneralFace) {
        console.log('onGeneralFaceChanged', face.type, FaceType.Unknown, face);
        this.onGeneralFaceSetted?.(face, face.type === FaceType.Unknown);
      }
    },
    onFacesInfo(info) {
      this.facesInfo = info;
    },
    checkFaceCount() {
      this.onFacesInfo(this.$robot.faceRecognizeService.getInfo());
      if (this.faces.length > 1) {
        this.onMultipleFaces?.();
        this.addGeneralFaceWatcher();
      } else {
        if (this.generalFace) {
          this.onGeneralFaceChanged(this.generalFace);
          return;
        }
        this.addGeneralFaceWatcher();
        this.onRecognizeStart?.();
      }
    },
    addGeneralFaceWatcher() {
      const unwatch = this.$watch('generalFace', this.onGeneralFaceChanged);
      this.$once('hook:beforeDestroy', unwatch);
    },
    initFaceActions() {
      const robotActions = [
        this.$robot.faceRecognizeService.onGeneralSetted(this.onGeneralSettedByTouch),
        this.$robot.faceRecognizeService.onInfo(this.onFacesInfo),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
